import React from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

import View from '../../../assets/images/view.svg'
import Download from '../../../assets/images/download.svg'
import Arrow from '../../../assets/images/arrow.svg'
import {
  viewDocument,
  downloadDocument,
  getImageUrl,
  isArabic,
} from '../../../utils'
import { BASE_APP_URL } from '../../../Contansts'

import styles from './PdfCard.module.scss'
import { useLanguage } from '../../../context/LangaugeContextProvider/LangaugeContextProvider'

const PdfCard = ({
  title,
  link,
  fileName,
  comingSoon,
  isView,
  isDownload,
  icon,
  isShow,
  handleShow,
}) => {
  const { language } = useLanguage()
  const handleView = () => {
    viewDocument(link)
  }

  const handleDownload = () => {
    downloadDocument(fileName, link)
  }
  return (
    <div className={classNames(styles['card-container'])}>
      <div
        className={classNames(
          styles.content,
          'flex flex-column justify-start h-full gap-4'
        )}
      >
        {icon && <img src={getImageUrl(icon)} className={styles.icon} alt="" />}
        <div className={classNames('flex flex-column justify-between h-full')}>
          <div className={classNames(styles.title)}>{title}</div>
          {comingSoon && (
            <div className={classNames(styles['coming-soon'])}>
              {comingSoon}
            </div>
          )}
        </div>
      </div>
      <div
        className={classNames(
          'absolute bottom-0 w-full flex items-center justify-end'
        )}
      >
        {link && (
          <div
            className={classNames(
              styles['animated-action-wrapper'],
              'bg-white relative',
              {
                [styles['arabic-animated-action-wrapper']]: isArabic(
                  language?.code
                ),
              }
            )}
          >
            <div className={classNames('flex gap-2')}>
              {isView && (
                <Link
                  to={BASE_APP_URL + link}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Open the document in new tab"
                >
                  <img
                    src={View}
                    alt="View"
                    className={classNames(styles['action-image'])}
                  />
                </Link>
              )}
              {isDownload && (
                <img
                  src={Download}
                  alt="Download"
                  className={classNames(styles['action-image'])}
                  onClick={handleDownload}
                />
              )}
              {isShow && (
                <img
                  src={Arrow}
                  alt="show"
                  className={classNames(styles['action-image'])}
                  onClick={handleShow}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default PdfCard
